export function formatCurrencyAUD(amount: number): string {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
}

/**
 * Today's date as a local-time `YYYY-MM-DD` string, suitable for
 * `<input type="date">` defaults. Uses `en-CA` (which formats as ISO) so the
 * date reflects the user's local day — unlike `toISOString()`, which is UTC and
 * rolls to tomorrow in the evening for negative-offset timezones.
 */
export function todayLocalISO(): string {
  return new Date().toLocaleDateString('en-CA');
}

/**
 * A `Date` as a local-time `YYYY-MM-DD` string. Same `en-CA`/local-day rationale
 * as {@link todayLocalISO} — avoids the UTC roll that `toISOString()` introduces.
 */
export function dateToLocalISO(date: Date): string {
  return date.toLocaleDateString('en-CA');
}
